import { defaultFontInput } from './constants/fontFamilies';

const FableticsRewardProgressBarToPlatinumBuilderComponent = {
  name: '_LoyaltyProgressBarToPlatinum_',
  inputs: [defaultFontInput],
} as const;

export default FableticsRewardProgressBarToPlatinumBuilderComponent;
